import * as yup from 'yup'

const createCompanyValidate = yup.object().shape({
    company_name: yup.string().required('Chưa nhập tên công ty'),
    company_address: yup.string().required('Chưa nhập địa chỉ'),
    company_tax: yup.string().required('Chưa nhập số thuế'),
})

export default createCompanyValidate
